import { _ as _define_property } from "@swc/helpers/_/_define_property";
export class IntegrationFailureModel {
    static fromScoutDTO(date, customFailure) {
        return new IntegrationFailureModel({
            date,
            customFailure: {
                code: customFailure.code,
                param: customFailure.param,
                paramPendingSync: customFailure.paramPendingSync,
                paramLink: undefined
            }
        });
    }
    static fromExternalInvoiceDTO(date, failure) {
        return new IntegrationFailureModel({
            date: new Date(date).getTime(),
            customFailure: {
                code: failure.code,
                param: failure.entity,
                paramPendingSync: failure.pendingDependencies != null ? {
                    invoicesToSync: failure.pendingDependencies.invoicesToSync.map((ref)=>({
                            id: ref.id,
                            status: ref.status,
                            formattedNumber: ref.invoiceNumber
                        })),
                    paymentsToSync: failure.pendingDependencies.paymentsToSync.map((ref)=>({
                            id: ref.id,
                            status: ref.status,
                            formattedNumber: ref.invoiceNumber
                        }))
                } : null,
                paramLink: undefined
            }
        });
    }
    failureCode() {
        return this.data.customFailure.code;
    }
    failureParam() {
        return this.data.customFailure.param;
    }
    invoicesToSync() {
        const { paramPendingSync } = this.data.customFailure;
        return paramPendingSync ? paramPendingSync.invoicesToSync : [];
    }
    paymentsToSync() {
        const { paramPendingSync } = this.data.customFailure;
        return paramPendingSync ? paramPendingSync.paymentsToSync : [];
    }
    date() {
        return new Date(this.data.date);
    }
    paramLink() {
        return this.data.customFailure.paramLink;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
